import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import apiInstance from "../../config/api";

export const updateUser = createAsyncThunk(
  "user/update",
  async (data) => {
    try {
      const request = await apiInstance.post('/api/user/profileupdate', data)
      const response = request.data

      if (response.status === 'success') {
        return response.data
      } else {
        throw new Error(response.message)
      }
    }
    catch (error) {
      throw new Error(error.message)
    }
  }
);

export const clearSearchResults = () => ({
  type: 'user/clearSearchResults',
});

export const getMyFriends = createAsyncThunk('user/friends', async () => {
  try {
    const request = await apiInstance.get('/api/friends/my-friends')
    const response = request.data
    if (response.status === "success") {
      const friends = response.personalFriends
      // console.log('my friends', friends)
      return friends
    } else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const getMyFilteredFriends = createAsyncThunk('user/filtered-friends', async (data) => {
  console.log(JSON.stringify(data));
  try {
    const request = await apiInstance.post('/api/friends/filtered-friends')
    const response = request.data
    if (response.status === "success") {
      return response.personalFriends; // Return the filtered friends
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
});


export const uploadProfilePics = createAsyncThunk('upload/profile-pics', async (formData) => {
  try {
    const request = await apiInstance.post('/image/api/profilepic/profile', formData)
    const response = request.data
    if (response.status === 'success') {
      const imageUrl = response.post.photoPublicUrl
      return imageUrl
    } else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const uploadCoverPhoto = createAsyncThunk('upload/cover-pics', async (formData) => {
  try {
    const request = await apiInstance.post('/image/api/cover/profile', formData)
    const response = request.data
    if (response.status === 'success') {
      const imageUrl = response.data.photoPublicUrl
      return imageUrl
    } else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const deleteProfilePicture = createAsyncThunk(
  "profile/deletePicture",
  async (userId, { rejectWithValue }) => {
    try {
      await apiInstance.delete(`/profilepic/${userId}`)
      return userId;
    } catch (error) {
      console.error("Delete Profile Picture Error:", error.message);
      return rejectWithValue(error.message);
    }
  }
);

export const searchUsers = createAsyncThunk(
  "user/search",
  async ({ searchQuery }) => {
    try {

      const response = await apiInstance.get(`/api/user/search/search-all-users?searchQuery=${searchQuery}`)
      const data = response.data

      if (data.message === 'Users received successfully') {
        return data.users;
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const updatePassword = createAsyncThunk('user/update-password', async (data) => {
  try {
    const request = await apiInstance.put('/api/user/updatepassword', data)
    const response = request.data

    if (response.message === "Password changed successfully") {

      return response
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const updateProfileImages = createAsyncThunk(
  'user/updateProfileImages',
  async ({ avatarFile, coverFile }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      
      if (avatarFile) {
        formData.append('avatar', avatarFile);
      }
      
      if (coverFile) {
        formData.append('coverPhoto', coverFile);
      }

      const response = await apiInstance.put('/api/user/update-images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.status === 'success') {
        toast.success('Profile images updated successfully!');
        return {
          profilePhoto: response.data.profilePhoto,
          coverPhoto: response.data.coverPhoto
        };
      } else {
        throw new Error(response.data.message || 'Failed to update images');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update images');
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteAccount = createAsyncThunk('user/delete', async (data) => {
  try {
    const request = await apiInstance.delete('api/user')
    const response = request.data

    if (response.status === "success") {
      return response
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})
